import React, { Component } from 'react';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import { withRouter } from 'react-router-dom'

// Services
import providersService from '@services/providers';

import 'react-confirm-alert/src/react-confirm-alert.css';
import { MdAddCircleOutline, MdVisibility } from "react-icons/md";
import ReactTable from '@components/ReactTable';
import Input from '@components/Input';

// Components
import Menu from '@components/Menu'

class Page extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    
    constructor(props) {
        super(props);


        this.state = {
            loaded: false,
            table: {
                columns: [
                    {
                      Header: 'Nome',
                      accessor: 'name',
                    },
                    {
                      Header: 'NIF',
                      accessor: 'nif',
                    },
                    {
                      Header: 'Morada',
                      accessor: 'address',
                    },
                    {
                      Header: 'Telefone',
                      accessor: 'phone',
                    },
                    {
                      Header: 'Email',
                      accessor: 'email',
                    },
                    {
                      Header: '',
                      accessor: 'view',
                    }
                ],
                rows: [],
                loading: true,
            },
            search: JSON.parse(localStorage.getItem("providers.search")) || "",
        };
        this.loadFunction = this.loadFunction.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
  
    async loadFunction() {
        if (!this.state.loaded) {
            const { history } = this.props;

            try {
                const providers = await providersService.get(this.props.cookies.get('member_idempresa'));

                const enrichedProviders = providers.map((provider) => ({
                        ...provider,
                        name: provider.idapollo && parseInt(provider.idapollo, 10) !== -1 ? `[${provider.idapollo}] ${provider.name}` : provider.name,
                        view: (<MdVisibility style={{ fontSize: '15px', cursor: 'pointer' }} onClick={ () => history.push(`/providers/${provider.idprovider}`) } />),
                }));

                this.setState({ table: { ...this.state.table , rows: enrichedProviders, loading: false }, loaded: true });
            } catch (error) {
                console.error(error);
            }
        }
    }

    filterData(searchTerm) {
        this.setState({ search: searchTerm });
    }

    handleChange(e, callback) {
        let value = e.target.value;
        let name = e.target.name;

        this.setState({
            [name]: value,
        }, () => {
            switch (name) {
                case "search":
                    localStorage.setItem(`providers.${name}`, JSON.stringify(value));
                    break;
                default:
                    break;
            }
        });
    }
    
    render () {
        const { table, search } = this.state;
        const { location, history } = this.props;
        const cookies = new URLSearchParams(location.search);

        const filterSearch = search.split(" ");

        const oneOfAll = (provider, search) => {
            const keys = Object.keys(provider);
            return keys.some((key) => `${provider[key] || ''}`.toLowerCase().includes(search.toLowerCase()))
        }

        const tableRows = table.rows.length
            ? table.rows.filter((provider) =>
                filterSearch.every(
                    (eachSearch) =>
                        eachSearch === "" ||
                        oneOfAll(provider, eachSearch)
                )
            )
            : [];

        return (
            <div>
                <Menu loadFunction={ this.loadFunction } location={ location } history={ history } newCookies={ cookies } />
                <div className="fullContainer" style={{ maxWidth: '100%' }}>
                    <div className="col-xs-12">
                        <ol
                            style={{
                                textAlign: 'left',
                                'marginTop': '75px',
                            }}
                            className="breadcrumb"
                        >
                            <li><a href="http://eposgestofinal.com/index.php">Portal</a></li>
                            <li className="active">Fornecedores</li>
                        </ol>
                    </div>
                </div>
                <div
                    className="fullContainer" style={{ maxWidth: '100%' }}
                >
                    <div
                        className="col-sm-12"
                        style={{ textAlign: 'center' }}
                    >
                        <div className="panel panel-default">
                            <div
                                className="panel-heading"
                                style={{
                                    fontWeight: 'bold',
                                    fontSize: '15pt',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '15px'
                                }}
                            >
                                <div
                                    style={{
                                        width: '100%',
                                        textAlign: 'left',
                                    }}
                                >
                                    Fornecedores
                                </div>
                                <div>
                                    <MdAddCircleOutline style={{ fontSize: '20px', cursor: 'pointer' }} onClick={ () => history.push('/providers/new') } />
                                </div>
                            </div>

                            <table className="table table-bordered table-hover table-sortable">
                                <thead>
                                    <tr>
                                        <th className="text-center">Pesquisa</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Input
                                                inputType={"text"}
                                                name={"search"}
                                                value={search}
                                                placeholder="pesquisa..."
                                                handleChange={(e) => this.filterData(e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <ReactTable
                                columns={ table.columns }
                                sortable={ true }
                                loading={ table.loading }
                                data={ tableRows }
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withCookies(withRouter(Page));